/*eslint-disable*/
import React from "react";
import Lottie from "react-lottie";
import confirmLottie from "assets/lotties/23212-order-packed.json";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import { CgCheck } from "react-icons/cg";

import { Box, Stepper, Step, StepLabel } from "@material-ui/core";

// views for this page
//import OrderStageOne from "trade-customer-portal/views/OrderProcessPage/Sections/OrderStageOnePage.js"
import FooterSection from "trade-customer-portal/views/footer.js";
import HeaderSection from "trade-customer-portal/views/header.js";
// styling
import orderStyle from "assets/jss/CustomerTradePortal/views/orderProcessPageStyle.js";

import OrderData from "../OrderConfirmation/Classes/OrderDetails.js";

import { useDispatch, useSelector } from "react-redux";
const useStyles = makeStyles(orderStyle);

import StepperView from "../../../Common/stepperPage.js";

export default function OrderProcessConfirmation() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  });

  const realex = useSelector((state) => state.userReducer.user.realex_Enabled);

  let stepVal = 2;

  if (realex === true) {
    stepVal = 3;
  }

  const classes = useStyles();

  const lottieSucess = {
    loop: true,
    autoplay: true,
    animationData: confirmLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  let lottieDisplay = (
    <Lottie options={lottieSucess} speed={1} height={370} width={500}>
      {" "}
    </Lottie>
  );

  return (
    <div>
      <HeaderSection />
      <div
        className={classNames(
          classes.main,
          classes.mainRaised,
          classes.mainSection,
          classes.sidePageMainSection
        )}
      >
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem
              md={7}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1 className={classes.title} style={{ color: "black" }}>Order Confirmation</h1>
            </GridItem>
            <GridItem
              md={7}
              sm={8}
              className={classNames(classes.mlAuto, classes.mrAuto)}
            >
              <div className={classes.sidePageBorderLine} />
            </GridItem>
          </GridContainer>

          <StepperView stepValue={stepVal} />

          <div style={{ padding: "0px 0px 25px 0px" }}>
            {lottieDisplay}
            {realex ? (
              <h3>
                {" "}
                Thank you, your payment was successful. Order has been
                confirmed. You will receive an email shortly confirming your
                recent order. Proceed to your main account page to see current
                order history or place another order
                <a href="" target="_blank">
                  {" "}
                  here.{" "}
                </a>{" "}
              </h3>
            ) : (
              <h3>
                Thank you, your order has been placed successfully. You will
                receive an email shortly confirming your recent order. Proceed
                to your main account page to see current order history or place
                another order
                <a href="" target="_blank">
                  {" "}
                  here.{" "}
                </a>
              </h3>
            )}
          </div>

          <OrderData />
        </div>
      </div>

      <FooterSection />
    </div>
  );
}
